import React, { Component } from 'react';
import { isAuthenticated } from '../auth';
import { read, update, updateUser } from './apiUser';
import { Redirect } from 'react-router-dom';
import LoadingAnim from '../core/LoadingAnim';
import DefaultProfile from '../assets/avatar.jpg';

export default class EditProfile extends Component {
    constructor() {
        super();
        this.state = {
            id: "",
            name: "",
            email: "",
            password: "",
            redirectToProfile: false,
            error: "",
            fileSize: 0,
            loading: false,
            about: ""
        }
    }

    init = userId => {
        const token = isAuthenticated().token;
        read(userId, token).then(data => {
            if (data.error) {
                this.setState({ redirectToProfile: true });
            } else {
                this.setState({ id: data._id, name: data.name, email: data.email, error: "", about: data.about });
            }
        })
    }

    componentDidMount() {
        this.userData = new FormData();
        const userId = this.props.match.params.userId;
        this.init(userId);
    }

    isValid = () => {
        const { name, email, password, fileSize } = this.state;

        if (fileSize > 1000000) {
            this.setState({ error: "Fils size must be less than 1MB." });
            return false;
        }

        if (name.length === 0) {
            this.setState({ error: "Please provide a Name." });
            return false;
        }
        /* eslint-disable-next-line */
        if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
            this.setState({ error: "Please provide a valid email." });
            return false;
        }

        if (password.length >= 1 && password.length <= 5) {
            this.setState({ error: "Password must be at least 6 characters long." });
            return false;
        }

        return true;
    };

    handleChange = name => event => {
        this.setState({ error: "" });
        const value = name === "photo" ? event.target.files[0] : event.target.value;
        const fileSize = name === "photo" ? event.target.files[0].size : 0;
        this.userData.set(name, value);
        this.setState({ [name]: value, fileSize });
        // update the image using FileReader //
        if(name === "photo"){
            const lReader = new FileReader();
            lReader.onload = function(e){
                document.getElementById('profile_photo').setAttribute('src',e.target.result);
            }
            lReader.readAsDataURL(event.target.files[0]);
        }
    }

    clickUpdate = event => {
        event.preventDefault();

        if (this.isValid()) {
            this.setState({ loading: true });

            //console.log(user);
            const userId = this.props.match.params.userId;
            const token = isAuthenticated().token;
            //console.log('this.userData:', this.userData );
            update(userId, token, this.userData)
                .then(data => {
                    if (data.error) {
                        //console.log('data.error:', data.error);
                        this.setState({ error: data.error });
                    } else {
                        updateUser(data, () => {
                            this.setState({ redirectToProfile: true });
                        });
                    }
                })
        }
    }

    signupForm = (name, email, password, about) => (
        <form>
            <div className="form-group">
                <label className="text-muted">Profile Photo</label>
                <input onChange={this.handleChange("photo")} type="file" accept="image/*" className="form-control" />
            </div>
            <div className="form-group">
                <label className="text-muted">Name</label>
                <input onChange={this.handleChange("name")} type="text" className="form-control" value={name} />
            </div>
            <div className="form-group">
                <label className="text-muted">Email Address</label>
                <input onChange={this.handleChange("email")} type="email" className="form-control" value={email} />
            </div>
            <div className="form-group">
                <label className="text-muted">About</label>
                <textarea onChange={this.handleChange("about")} type="text" className="form-control" value={about} />
            </div>
            <div className="form-group">
                <label className="text-muted">Password</label>
                <input onChange={this.handleChange("password")} type="password" className="form-control" value={password} />
            </div>
            <button onClick={this.clickUpdate} className="btn btn-raised btn-success">Update</button>
        </form>
    )

    render() {
        const { id, name, email, password, redirectToProfile, error, loading, about } = this.state;
        if (redirectToProfile) {
            return <Redirect to={`/user/${id}`} />
        }

        const lDate = Date.now();
        const photoUrl = id ? `${process.env.REACT_APP_API_URL}/user/photo/${id}?v=${lDate}` : DefaultProfile;

        return (
            <div className="container">
                <h2 className="mt-5">Edit Profile</h2>
                {loading ? <LoadingAnim /> : <img
                    id="profile_photo"
                    src={photoUrl}
                    onError={i => (i.target.src = `${DefaultProfile}`)}
                    className="img-thumbnail rounded-circle"
                    style={{ height: 200, width: 200, margin: 'auto'}}
                    alt={name}
                />}
                {!loading ? this.signupForm(name, email, password, about) : null}
                <div className="alert alert-danger" style={{ visibility: error ? "visible" : "hidden" }}>
                    {error}
                </div>

            </div>
        )
    }
}
